/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnaireConfigRecommendedStrategyFund
 */
export interface QuestionnaireConfigRecommendedStrategyFund {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategyFund
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategyFund
     */
    maxPercentageAllocation: number;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategyFund
     */
    recommendedPercentageAllocation: number;
}

/**
 * Check if a given object implements the QuestionnaireConfigRecommendedStrategyFund interface.
 */
export function instanceOfQuestionnaireConfigRecommendedStrategyFund(value: object): value is QuestionnaireConfigRecommendedStrategyFund {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('maxPercentageAllocation' in value) || value['maxPercentageAllocation'] === undefined) return false;
    if (!('recommendedPercentageAllocation' in value) || value['recommendedPercentageAllocation'] === undefined) return false;
    return true;
}

export function QuestionnaireConfigRecommendedStrategyFundFromJSON(json: any): QuestionnaireConfigRecommendedStrategyFund {
    return QuestionnaireConfigRecommendedStrategyFundFromJSONTyped(json, false);
}

export function QuestionnaireConfigRecommendedStrategyFundFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireConfigRecommendedStrategyFund {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'maxPercentageAllocation': json['maxPercentageAllocation'],
        'recommendedPercentageAllocation': json['recommendedPercentageAllocation'],
    };
}

export function QuestionnaireConfigRecommendedStrategyFundToJSON(json: any): QuestionnaireConfigRecommendedStrategyFund {
    return QuestionnaireConfigRecommendedStrategyFundToJSONTyped(json, false);
}

export function QuestionnaireConfigRecommendedStrategyFundToJSONTyped(value?: QuestionnaireConfigRecommendedStrategyFund | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'maxPercentageAllocation': value['maxPercentageAllocation'],
        'recommendedPercentageAllocation': value['recommendedPercentageAllocation'],
    };
}

